import { render, staticRenderFns } from "./ModifyZimbraPackageModal.vue?vue&type=template&id=7d1b22cc&"
import script from "./ModifyZimbraPackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifyZimbraPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports